import img1 from '../../assets/Tes/1.JPG'
import img2 from '../../assets/Tes/2.JPG'
import img3 from '../../assets/Tes/3.JPG'
import img4 from '../../assets/Tes/4.JPG'
import img5 from '../../assets/Tes/5.JPG'
import img6 from '../../assets/Tes/6.JPG'
import img7 from '../../assets/Tes/7.JPG'
import img8 from '../../assets/Tes/8.JPG'
import img9 from '../../assets/Tes/9.JPG'
import img10 from '../../assets/Tes/10.JPG'
import img11 from '../../assets/Tes/11.jpg'
import img12 from '../../assets/Tes/12.jpg'
import img13 from '../../assets/Tes/13.jpg'
import img14 from '../../assets/Tes/14.jpg'
import img15 from '../../assets/Tes/15.jpg'

export const Tes = [
    // img1,
    img2,
    // img3,
    img4,
    // img5,
    img6,
    img7,
    // img8,
    img9,
    img10,
    img11,
    img12,
    // img13,
    // img14,
    // img15,
]
